// @flow
import React, { useEffect } from 'react';
import { Icon } from '@finect/tabular-components/Icon';
import { decodeHtmlEntities } from '@finect/front-utils/html';
import { withContext } from '../../../../HOC';
import type { WithContextProps } from '../../../../HOC';
import { NavTitle, ProfessionalNav, ProfessionalInfo } from '../../../../components';
import { Navigation, InsideNavigation } from './InsideNavigation';

type Props = {
  article: Object,
  omniNavState: string
} & WithContextProps;

export const ArticleNavigation: any = withContext((props: Props) => {
  const isCompany = props.article.author.subtype === 'company';
  const companyHasBlog = isCompany && props.article.author.features?.blog && !props.article.author.private;

  const title = decodeHtmlEntities(props.article.title);

  const content = isCompany ? (
    <ProfessionalNav>
      <ProfessionalInfo>
        {companyHasBlog ? (
          <a
            href={`/grupos/${props.article.author.alias}`}
            alt={`Perfil del grupo ${props.article.author.displayName}`}
          >
            <Icon
              size={1}
              alt={props.article.author.displayName}
              image={`/image/${props.article.author.icon}`}
              margin="0 12px 0 0"
              type="company"
              verified
            />
          </a>
        ) : (
          <Icon
            size={1}
            alt={props.article.author.displayName}
            image={`/image/${props.article.author.icon}`}
            margin="0 12px 0 0"
            type="company"
            verified
          />
        )}
        <strong>{props.article.author.displayName}</strong>
      </ProfessionalInfo>
      <NavTitle>{title}</NavTitle>
    </ProfessionalNav>
  ) : (
    <NavTitle>{title}</NavTitle>
  );

  const validContext = props.contextProps.context.find(item => item.model?.back);

  // use useEffect as componentwillunmount
  useEffect(() => () => props.contextActions.clearContext(), []);

  return (
    <Navigation>
      <InsideNavigation centered omniNavState={props.omniNavState} back={validContext ? validContext.model : null}>
        {content}
      </InsideNavigation>
    </Navigation>
  );
});
